/**
 * #1113: the close dialog's case coverage follows the time entry's Billing choice.
 * Not billable records Covered. Billable records Billable. An unknown agreement is not a
 * contradiction — the billing choice fills it. A known agreement that says something else
 * (including Partly covered) is a contradiction, and the full case-coverage section stays open.
 */

export const FROM_TIME_ENTRY_BASIS = 'From your time entry'

const KNOWN = new Set(['covered', 'billable', 'partial'])

export function decisionFromBilling(billable: boolean): 'covered' | 'billable' {
  return billable ? 'billable' : 'covered'
}

/** The agreement answer the close dialog can compare with Billing. A stored person decision is not the agreement. */
export function knownAgreement(line: string | null | undefined, prompt: string | null | undefined): string | null {
  for (const value of [line, prompt]) {
    if (value && KNOWN.has(value)) return value
  }
  return null
}

export function billingContradictsAgreement(billable: boolean, agreement: string | null | undefined): boolean {
  if (!agreement || !KNOWN.has(agreement)) return false
  return agreement !== decisionFromBilling(billable)
}

export function basisForFollow(
  decision: 'covered' | 'billable',
  line: { decision: string; basis: string } | null | undefined,
  prompt: { decision: string; basis: string } | null | undefined,
): string {
  if (line && line.decision === decision && line.basis.trim().length >= 3) return line.basis.trim()
  if (prompt && prompt.decision === decision && prompt.basis.trim().length >= 3) return prompt.basis.trim()
  return FROM_TIME_ENTRY_BASIS
}
